<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-3">
        If you have a buffer solution that contains
        <number-value :value="baseConc" unit="\text{M}" />
        of a weak base and
        <number-value :value="acidConc" unit="\text{M}" />
        of its conjugate acid, determine the
        <stemble-latex content="$\text{pH}$" />
        of the solution if the
        <stemble-latex content="$\text{K}_\text{b}$" />
        of the weak base is
        <number-value :value="Kb" unit="." style="white-space: nowrap" />
      </p>

      <calculation-input
        v-model="inputs.pH"
        prepend-text="$\text{pH:}$"
        :disabled="!allowEditing"
      />
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import CalculationInput from '../inputs/CalculationInput';
import NumberValue from '../NumberValue';
import StembleLatex from '@/tasks/components/StembleLatex';

export default {
  name: 'Question147',
  components: {
    StembleLatex,
    CalculationInput,
    NumberValue,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      // Put a list of inputs or computed properties here to be sent for marking
      inputs: {
        pH: null,
      },
    };
  },
  computed: {
    acidConc() {
      return this.taskState.getValueBySymbol('acidConc').content;
    },
    baseConc() {
      return this.taskState.getValueBySymbol('baseConc').content;
    },
    Kb() {
      return this.taskState.getValueBySymbol('Kb').content;
    },
  },
};
</script>
